import { ViewStorePageProps } from './view-store-page.types'
import styles from './view-store-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import {
  Button,
  EntityInfoNameLine,
  H2,
  HorizontalLine,
  ImagesSection,
  LabeledLine,
  PageContainer,
  PageHeader,
  SectionContainer,
  TagsEditor,
  Text1,
  getImagePortraitProps,
  getMainImageSrcForObj,
  secureString,
  IconSuccessSmall
} from '@touche-lts/panel-ui/dist'
import {
  IconDeleteCircle,
  IconEmail,
  IconInfoSmall,
  IconStatistics,
  IconStores,
  IconViewers
} from 'assets/icons'
import moment from 'moment'
import { UsersInShopSection } from 'components'
import { StoreProductsSection } from './store-products-section'
import { settings } from 'config'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const ViewStorePageComponent = (props: ViewStorePageProps) => {
  const {
    className,
    style,
    match: {
      params: { storeId }
    },
    history: { push }
  } = props

  const {
    viewStorePageStore: {
      onPageMount,
      clearStore,
      store,
      addedUsersToStore,
      onRemoveUserClick,
      onSuspendStoreClick,
      onActivateClick
    }
  } = useRootStore()

  useEffect(() => {
    onPageMount(storeId)
    return clearStore
  }, [onPageMount, storeId, clearStore])

  const {isResponsive: isLargeMobile} = useGetIsResponsiveScreen('(max-width:920px)')
  if (!store) return null

  return (
    <PageContainer className={cl(className, styles.scrollable)} style={ {...style,  overflowX : "hidden" }}>
      <PageHeader
        navSegments={[
          {
            label: 'Stores',
            icon: IconStores,
            iconProps: { style: { marginBottom: -5 } },
            onClick: () => push('/stores')
          },
          {
            label: store.name
          }
        ]}
      />
      <SectionContainer extraPaddingBottom>
        <EntityInfoNameLine
          entityName={store.name}
          imageProps={getImagePortraitProps(
            getMainImageSrcForObj(store),
            'image'
          )}
          ratingProps={{
            rating: store.rating,
            reviewsCnt: store.reviewsCnt
          }}
        />
        <div className={styles.topRightContainer}>
          <Button preset='link' className={styles.linkButton} onClick={() => push({ pathname: '/statistics', state: { storeName: store.name, storeId: store.id } })}>
            <IconStatistics />
            View statistics
          </Button>
          {store.status === "ACTIVE" && (
         // <Button preset='link' className={styles.linkButton} onClick={() => window.open(`http://tech-marketplace.s3-website.eu-central-1.amazonaws.com/stores/${storeId}`, "_blank")}>
            <Button preset='link' className={styles.linkButton} onClick={() => window.open(`${settings.MARKET_PLACE_URL}/stores/${storeId}`, "_blank")}>
              <IconViewers />
              View in marketplace
            </Button>
          )}
        </div>
        <div className={!isLargeMobile && styles.proportionFlexBox}>
          <div>
            <LabeledLine
              className={styles.inputLine}
              label='Email'
              labelIcon={IconEmail}
            >
              <Text1>{store.email}</Text1>
            </LabeledLine>
            <LabeledLine className={styles.inputLine} label='Registered on'>
              <Text1>{moment(store.createdDate).format('DD.MM.YYYY')}</Text1>
            </LabeledLine>
            <LabeledLine className={styles.inputLine} label='Website URL'>
              <Text1>{store.websiteUrl}</Text1>
            </LabeledLine>
            <LabeledLine
              className={styles.inputLine}
              alignItems='stretch'
              label='Tags'
            >
              <TagsEditor tags={store.tags} />
            </LabeledLine>
            {/* <Button preset='link' className={styles.inputLine}>
              Reset password
            </Button> */}
          </div>
          <LabeledLine
            className={styles.inputLine}
            alignItems='stretch'
            label='Description'
          >
            <Text1>{store.info}</Text1>
          </LabeledLine>
        </div>
        <HorizontalLine />
        <H2 className={styles.sectionHeading}>
          Payment details{' '}
          <IconInfoSmall title='Some info about payment details' />
        </H2>
        <div className={!isLargeMobile && styles.proportionFlexBox}>
          <LabeledLine className={styles.inputLine} label='Username'>
            <Text1>{store.paymentDetails?.username}</Text1>
          </LabeledLine>
          <LabeledLine className={styles.inputLine} label='Password'>
            <Text1>{secureString(store.paymentDetails?.password)}</Text1>
          </LabeledLine>
        </div>
        <div className={!isLargeMobile && styles.proportionFlexBox}>
          <LabeledLine className={styles.inputLine} label='Business ID'>
            <Text1>{store.paymentDetails?.businessId}</Text1>
          </LabeledLine>
          <LabeledLine className={styles.inputLine} label='Token'>
            <Text1>{secureString(store.paymentDetails?.token)}</Text1>
          </LabeledLine>
        </div>
        {/* Shopify Integration */}
        {
          store.shopifyStoreUrl && store.shopifyAccessToken &&
          <>
           <H2 className={styles.sectionHeading}>
           Shopify details{' '}
          <IconInfoSmall title='Some info about shopify details' />
        </H2>
        <div className={!isLargeMobile && styles.proportionFlexBox}>
          <LabeledLine className={styles.inputLine} label='Shopify Store URL'>
            <Text1>{store.shopifyStoreUrl}</Text1>
          </LabeledLine>
           <LabeledLine className={styles.inputLine} label='Shopify Access Token'>
            <Text1>{secureString(store.shopifyAccessToken)}</Text1>
          </LabeledLine>
        </div>
        <div className={!isLargeMobile && styles.proportionFlexBox}>
        <LabeledLine className={styles.inputLine} label='Shopify API Secret'>
            <Text1>{secureString(store.shopifyAccessToken)}</Text1>
          </LabeledLine>
           <LabeledLine className={styles.inputLine} label='Shopify Storefront Token'>
            <Text1>{secureString(store.shopifyStorefrontToken)}</Text1>
          </LabeledLine>
        </div>
         
          </>
        }
        {Boolean(store.images && store.images.length) && (
          <>
            <HorizontalLine />
            <Text1 bold className={styles.sectionHeading}>
              Images
            </Text1>
            <ImagesSection images={store.images} />
          </>
        )}
        {store.status === "DELETED" ? (
          <Button
            preset='link'
            className={styles.activateStoreButton}
            title='Activate store'
            onClick={onActivateClick}
          >
            <IconSuccessSmall />
            Activate Store
          </Button>
        ) : (
          <Button
            preset='link'
            className={styles.suspendStoreButton}
            title='Suspend store'
            onClick={onSuspendStoreClick}
          >
            <IconDeleteCircle />
            Suspend store
          </Button>
        )}
      </SectionContainer >
      <UsersInShopSection
        key={storeId}
        className={styles.section}
        addedUsers={addedUsersToStore}
        onRemoveUserClick={onRemoveUserClick}
      />
      <StoreProductsSection className={styles.section} />
    </PageContainer >
  )
}

const ViewStorePage = observer(ViewStorePageComponent)
export { ViewStorePage }
